// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"700e9ee6","3874":"7f666381","5589":"f0aca72f","7110":"f3f76027","7341":"fcfa56e7","7809":"df728628","9183":"2ce6ec86","9306":"f12de9cd"}[chunkId] + ".css";
};